export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const STREET_ADDRESS = 'streetAddress';
export const ZIP_CODE = 'zipCode';
export const CITY = 'city';
export const PHONE_NUMBER = 'phoneNumber';
export const PHONE_NUMBER_MIN_LENGTH = 'phoneNumberMinLength';
export const PHONE_NUMBER_MAX_LENGTH = 'phoneNumberMaxLength';
export const EMAIL = 'email';
export const COMPANY_NAME = 'companyName';
export const SSN_ORG_NUMBER = 'ssnOrgNumber';
export const INDIVIDUAL_TYPE = 'individualType';
